import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de sommeil sain - Calculez l'heure d'eveil ou de sommeil optimal";
const DESCRIPTION =
  "Calculatrice de sommeil sain - Calculez l en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de sommeil sain l, calculatrice de sommeil sain l, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/sleep/";

const data1 = [
  { ageGroup: "0-3 mois", recommendedHours: "14-17 heures" },
  { ageGroup: "4-12 mois", recommendedHours: "12-16 heures sur 24h incluant la sieste" },
  { ageGroup: "1-2 ans", recommendedHours: "11-14 heures sur 24h incluant la sieste" },
  { ageGroup: "3-5 ans", recommendedHours: "10-13 heures sur 24h incluant la sieste" },
  { ageGroup: "6-12 ans", recommendedHours: "9-12 heures sur 24 heures" },
  { ageGroup: "13-18 ans", recommendedHours: "8-10 heures sur 24 heures" },
  { ageGroup: "18-60 ans", recommendedHours: "7 heures ou plus par nuit" },
  { ageGroup: "61-64 ans", recommendedHours: "7-9 heures" },
  { ageGroup: "65 ans et plus", recommendedHours: "7-8 heures" },
];

function SleepCalculator() {
  const [sleepType, setSleepType] = useState("wakeup");
  const [hours, setHours] = useState(7);
  const [minutes, setMinutes] = useState(0);
  const [pmAm, setPmAm] = useState("AM");
  const [sleepCycle, setSleepCycle] = useState(90);
  const [takesToSleep, setTakesToSleep] = useState(15);
  const [sleepCycleError, setSleepCycleError] = useState("");
  const [takesToSleepError, setTakesToSleepError] = useState("");
  const [result1, setResult1] = useState("");

  const [sleepType2, setSleepType2] = useState("wakeup");
  const [hours2, setHours2] = useState(7);
  const [minutes2, setMinutes2] = useState(0);
  const [pmAm2, setPmAm2] = useState("AM");
  const [sleepHours, setSleepHours] = useState(8);
  const [sleepMinutes, setSleepMinutes] = useState(0);
  const [result2, setResult2] = useState("");

  const handleTakesToSleepChange = (e) => {
    const val = e.target.value;
    if (!isNaN(val)) { setTakesToSleep(val); setTakesToSleepError(""); }
    else setTakesToSleepError("Veuillez entrer un nombre valide");
  };

  const handleSleepCycleChange = (e) => {
    const val = e.target.value;
    if (!isNaN(val)) { setSleepCycle(val); setSleepCycleError(""); }
    else setSleepCycleError("Veuillez entrer un nombre valide");
  };

  const handleSubmitCycle = (e) => {
    e.preventDefault();
    let h = parseInt(hours);
    let m = parseInt(minutes);
    if (pmAm === "PM" && h !== 12) h += 12;
    if (pmAm === "AM" && h === 12) h = 0;
    const baseMin = h * 60 + m;
    const cycleMin = parseInt(sleepCycle);
    const fallAsleepMin = parseInt(takesToSleep);
    const recommended = [];
    const other = [];

    if (sleepType === "wakeup") {
      for (let i = 6; i >= 1; i--) {
        let t = baseMin - i * cycleMin - fallAsleepMin;
        if (t < 0) t += 1440;
        let bh = Math.floor(t / 60); let bm = t % 60;
        let p = "AM"; if (bh >= 12) { p = "PM"; if (bh > 12) bh -= 12; } if (bh === 0) bh = 12;
        const entry = { hours: bh, minutes: bm, period: p, cycles: i };
        if (i >= 5) recommended.push(entry); else other.push(entry);
      }
      let html = `<p>Pour vous reveiller en forme a <b>${hours}:${String(minutes).padStart(2,"0")} ${pmAm}</b>, il est recommande d'aller dormir a :</p>`;
      recommended.forEach(b => { html += `<div><b style="color:green">${b.hours}:${String(b.minutes).padStart(2,"0")} ${b.period} (${b.cycles} cycle${b.cycles>1?"s":""} de sommeil)</b></div>`; });
      html += `<p>Autres options :</p>`;
      other.forEach(b => { html += `<div>${b.hours}:${String(b.minutes).padStart(2,"0")} ${b.period} (${b.cycles} cycle${b.cycles>1?"s":""})</div>`; });
      setResult1(html);
    } else {
      for (let i = 1; i <= 6; i++) {
        let t = baseMin + i * cycleMin + fallAsleepMin;
        if (t >= 1440) t -= 1440;
        let wh = Math.floor(t / 60); let wm = t % 60;
        let p = "AM"; if (wh >= 12) { p = "PM"; if (wh > 12) wh -= 12; } if (wh === 0) wh = 12;
        const entry = { hours: wh, minutes: wm, period: p, cycles: i };
        if (i >= 5) recommended.push(entry); else other.push(entry);
      }
      let html = `<p>Si vous vous couchez a <b>${hours}:${String(minutes).padStart(2,"0")} ${pmAm}</b>, eveillez-vous a :</p>`;
      recommended.forEach(w => { html += `<div><b style="color:green">${w.hours}:${String(w.minutes).padStart(2,"0")} ${w.period} (${w.cycles} cycle${w.cycles>1?"s":""} de sommeil)</b></div>`; });
      html += `<p>Autres options :</p>`;
      other.forEach(w => { html += `<div>${w.hours}:${String(w.minutes).padStart(2,"0")} ${w.period} (${w.cycles} cycle${w.cycles>1?"s":""})</div>`; });
      setResult1(html);
    }
  };

  const onReset1 = () => { setSleepType("wakeup"); setHours(7); setMinutes(0); setPmAm("AM"); setSleepCycle(90); setTakesToSleep(15); setSleepCycleError(""); setTakesToSleepError(""); setResult1(""); };

  const handleSubmitLength = (e) => {
    e.preventDefault();
    let h2 = parseInt(hours2); let m2 = parseInt(minutes2);
    if (pmAm2 === "PM" && h2 !== 12) h2 += 12;
    if (pmAm2 === "AM" && h2 === 12) h2 = 0;
    const sh = parseInt(sleepHours); const sm = parseInt(sleepMinutes);
    if (sleepType2 === "wakeup") {
      let wakeTotal = h2 * 60 + m2;
      let bedTotal = wakeTotal - sh * 60 - sm;
      if (bedTotal < 0) bedTotal += 1440;
      let bh = Math.floor(bedTotal / 60); let bm = bedTotal % 60;
      let p = "AM"; if (bh >= 12) { p = "PM"; if (bh > 12) bh -= 12; } if (bh === 0) bh = 12;
      setResult2(`<div>Vous devriez vous coucher a : <b style="color:green">${bh}:${String(bm).padStart(2,"0")} ${p}</b></div>`);
    } else {
      let bedTotal = h2 * 60 + m2;
      let wakeTotal = bedTotal + sh * 60 + sm;
      if (wakeTotal >= 1440) wakeTotal -= 1440;
      let wh = Math.floor(wakeTotal / 60); let wm = wakeTotal % 60;
      let p = "AM"; if (wh >= 12) { p = "PM"; if (wh > 12) wh -= 12; } if (wh === 0) wh = 12;
      setResult2(`<div>Vous devriez vous reveiller a : <b style="color:green">${wh}:${String(wm).padStart(2,"0")} ${p}</b></div>`);
    }
  };

  const onReset2 = () => { setSleepType2("wakeup"); setHours2(7); setMinutes2(0); setPmAm2("AM"); setSleepHours(8); setSleepMinutes(0); setResult2(""); };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8"><FirstAds /></div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Utilisez cette calculatrice pour determiner les heures optimales de coucher ou de reveil selon vos cycles de sommeil naturels, ou calculez a quelle heure vous reveiller selon la duree souhaitee.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />

            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">Calculatrice de cycles de sommeil</div>
                <hr />
                <form onSubmit={handleSubmitCycle}>
                  <div style={{ display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center", marginBottom:"16px" }}>
                    <b><label>Je veux</label></b>
                    <div style={{ display:"flex", gap:"24px", marginTop:"8px" }}>
                      <label style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        <input type="radio" value="wakeup" checked={sleepType==="wakeup"} onChange={(e)=>setSleepType(e.target.value)} />
                        Me reveiller a l'heure
                      </label>
                      <label style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        <input type="radio" value="goToSleep" checked={sleepType==="goToSleep"} onChange={(e)=>setSleepType(e.target.value)} />
                        M'endormir a l'heure
                      </label>
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems:"flex-end", gap:"10px" }}>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Heure</label>
                      <select value={hours} onChange={(e)=>setHours(e.target.value)} required className="form-control" style={{ width:"80px" }}>
                        {Array.from({length:12},(_,i)=>i+1).map(h=><option key={h} value={h}>{h}</option>)}
                      </select>
                    </div>
                    <span style={{ marginBottom:"8px" }}>:</span>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Minutes</label>
                      <select value={minutes} onChange={(e)=>setMinutes(e.target.value)} required className="form-control" style={{ width:"80px" }}>
                        {Array.from({length:60},(_,i)=>i).map(m=><option key={m} value={m}>{String(m).padStart(2,"0")}</option>)}
                      </select>
                    </div>
                    <span style={{ marginBottom:"8px" }}>:</span>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Periode</label>
                      <select value={pmAm} onChange={(e)=>setPmAm(e.target.value)} className="form-control" style={{ width:"90px" }}>
                        <option value="AM">Matin</option>
                        <option value="PM">Soir</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems:"center" }}>
                    <span>Duree de mon cycle de sommeil :</span>
                    <input value={sleepCycle} onChange={handleSleepCycleChange} required className="form-control d-inline-block" style={{ width:"80px", margin:"0 5px" }} />
                    <span>minutes</span>
                  </div>
                  {sleepCycleError && <div className="text-danger">{sleepCycleError}</div>}
                  <div className="mb-3 d-flex" style={{ alignItems:"center" }}>
                    <span>Je mets</span>
                    <input value={takesToSleep} onChange={handleTakesToSleepChange} required className="form-control d-inline-block" style={{ width:"80px", margin:"0 5px" }} />
                    <span>minutes pour m'endormir</span>
                  </div>
                  {takesToSleepError && <div className="text-danger">{takesToSleepError}</div>}
                  <hr />
                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight:"10px", padding:"5px 25px" }}>Calculer</button>
                    <button type="button" className="btn btn-secondary" style={{ padding:"5px 25px" }} onClick={onReset1}>Effacer</button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6">
                {result1 && <div dangerouslySetInnerHTML={{ __html: result1 }} />}
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">Calculatrice de duree de sommeil</div>
                <hr />
                <form onSubmit={handleSubmitLength}>
                  <div style={{ display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center", marginBottom:"16px" }}>
                    <b><label>Je veux</label></b>
                    <div style={{ display:"flex", gap:"24px", marginTop:"8px" }}>
                      <label style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        <input type="radio" value="wakeup" checked={sleepType2==="wakeup"} onChange={(e)=>setSleepType2(e.target.value)} />
                        Me reveiller a l'heure
                      </label>
                      <label style={{ display:"flex", alignItems:"center", gap:"6px" }}>
                        <input type="radio" value="goToSleep" checked={sleepType2==="goToSleep"} onChange={(e)=>setSleepType2(e.target.value)} />
                        M'endormir a l'heure
                      </label>
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems:"flex-end", gap:"10px" }}>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Heure</label>
                      <select value={hours2} onChange={(e)=>setHours2(e.target.value)} required className="form-control" style={{ width:"80px" }}>
                        {Array.from({length:12},(_,i)=>i+1).map(h=><option key={h} value={h}>{h}</option>)}
                      </select>
                    </div>
                    <span style={{ marginBottom:"8px" }}>:</span>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Minutes</label>
                      <select value={minutes2} onChange={(e)=>setMinutes2(e.target.value)} required className="form-control" style={{ width:"80px" }}>
                        {Array.from({length:60},(_,i)=>i).map(m=><option key={m} value={m}>{String(m).padStart(2,"0")}</option>)}
                      </select>
                    </div>
                    <span style={{ marginBottom:"8px" }}>:</span>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Periode</label>
                      <select value={pmAm2} onChange={(e)=>setPmAm2(e.target.value)} className="form-control" style={{ width:"90px" }}>
                        <option value="AM">Matin</option>
                        <option value="PM">Soir</option>
                      </select>
                    </div>
                  </div>
                  <b><label>Je veux dormir pendant</label></b>
                  <div className="mb-3 d-flex" style={{ alignItems:"flex-end", gap:"10px", marginTop:"8px" }}>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Heures</label>
                      <select value={sleepHours} onChange={(e)=>setSleepHours(e.target.value)} required className="form-control" style={{ width:"100px" }}>
                        {Array.from({length:13},(_,i)=>i).map(h=><option key={h} value={h}>{h}</option>)}
                      </select>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column" }}>
                      <label style={{ fontSize:"13px", marginBottom:"4px" }}>Minutes</label>
                      <select value={sleepMinutes} onChange={(e)=>setSleepMinutes(e.target.value)} required className="form-control" style={{ width:"100px" }}>
                        {Array.from({length:60},(_,i)=>i).map(m=><option key={m} value={m}>{String(m).padStart(2,"0")}</option>)}
                      </select>
                    </div>
                  </div>
                  <hr />
                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight:"10px", padding:"5px 25px" }}>Calculer</button>
                    <button type="button" className="btn btn-secondary" style={{ padding:"5px 25px" }} onClick={onReset2}>Effacer</button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6">
                {result2 && <div dangerouslySetInnerHTML={{ __html: result2 }} />}
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize:"16px" }}>Heures de sommeil recommandees par age</h2>
                </div>
                <div className="p-3">
                  <table className="table">
                    <thead>
                      <tr><th>Groupe d'age</th><th>Heures recommandees</th></tr>
                    </thead>
                    <tbody>
                      {data1.map((item, index) => (
                        <tr key={index}><td>{item.ageGroup}</td><td>{item.recommendedHours}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize:"16px" }}>L'importance du sommeil pour la sante</h3></div>
              <div className="info-section-body">
                <p>Le sommeil est essentiel pour la sante physique et mentale. Pendant le sommeil, le corps se regenere, consolide la memoire et renforce le systeme immunitaire. Un manque chronique de sommeil augmente le risque de maladies cardiovasculaires, d'obesite, de diabete de type 2 et de depression. Les adultes ont besoin de 7 a 9 heures par nuit.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize:"16px" }}>Comment fonctionnent les cycles de sommeil</h3></div>
              <div className="info-section-body">
                <p>Le sommeil se deroule en cycles de 90 minutes environ, chacun compose de 4 phases :</p>
                <ul>
                  <li><strong>Phase 1 (sommeil leger) :</strong> transition entre la veille et le sommeil</li>
                  <li><strong>Phase 2 :</strong> la temperature corporelle baisse, le rythme cardiaque ralentit</li>
                  <li><strong>Phase 3 (sommeil profond) :</strong> la plus reparatrice, cruciale pour la recuperation physique</li>
                  <li><strong>Phase REM :</strong> le cerveau est tres actif, c'est la que l'on reve et que la memoire se consolide</li>
                </ul>
                <p>Se reveiller a la fin d'un cycle permet de se lever repose. Cette calculatrice planifie votre heure de coucher ou de reveil en respectant ces cycles naturels.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize:"16px" }}>Conseils pour ameliorer la qualite du sommeil</h3></div>
              <div className="info-section-body">
                <ul>
                  <li>Respecter des horaires reguliers de coucher et de reveil, meme le week-end</li>
                  <li>Eviter les ecrans 30 a 60 minutes avant de dormir - la lumiere bleue retarde la melatonine</li>
                  <li>Maintenir une chambre fraiche (18-20 C), sombre et silencieuse</li>
                  <li>Eviter la cafeine apres 14h et l'alcool le soir (il perturbe le sommeil profond)</li>
                  <li>Eviter les repas lourds dans les 2 heures precedant le coucher</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SleepCalculator;
